import { connect } from 'react-redux';
import DuplicateModal from '../duplicate/DuplicateModal';
import { duplicateBallast } from '../../redux/luminaire/ballast_actions';

const mapStateToProps = state => ({
  isDuplicating: state.lighting.ballast.isDuplicating,
  errorMessage: state.lighting.ballast.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  duplicate: (id, name) => dispatch(duplicateBallast(id, name)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DuplicateModal);


// WEBPACK FOOTER //
// ./src/modal/ballast/BallastDuplicateModal.js